var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":_vm.defaultNotificationalertPlace}},[_c('notification-alert',{ref:"notificationAlert"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }